module.exports = __webpack_public_path__ + "img/Home_Img4.5796f1e2.jpg";